<template>
  <base-modal :show="show"
              size="small"
              @close="close" >
    <request-action-confirm :request="fromBus.request"
                            :action="fromBus.action"
                            @close="close" />
  </base-modal>
</template>

<script>
  import RequestActionConfirm from '@/components/Common/ManageRequests/RequestActionConfirm'
  import modalMixin from '@/mixins/modalMixin.js'

  export default {
    mixins: [
      modalMixin
    ],

    components: {
      RequestActionConfirm
    },

    data() {
      return {
        fromBus: {
          request: null,
          action: null,
        }
      }
    },

    beforeMount() {
      this.setOpenListener('requestAction')
    }
  }
</script>
